import { LicenseInfo } from '@mui/x-license'

/**
 * This license key is a Pro license valid from 2026-03-18 to 2027-03-18 included.
 * It allows access to some paid components.
 * It's not private as it's in the public bundle, so it's hardcoded here.
 *
 * Note that there's no urge to update the license before it expires:
 *
 * - Production usage is perpetual, so once expired, it still works fine on production
 * - In development, however, a watermark is added
 *
 */
const MUI_X_LICENSE_KEY =
  '816d926b5f7478ea74b282cfda7fe9afTz0xMjY3ODIsRT0xODA1NTAwNzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI='

let licensesSetup = false

export function setupLicenses(): void {
  if (licensesSetup) return

  LicenseInfo.setLicenseKey(MUI_X_LICENSE_KEY)
  licensesSetup = true
}
